import swal from "sweetalert";
import { jsPDF } from "jspdf";

import { isTouchEnabled } from "@/App.vue";
import { getFormattedDate, saveFile } from "@/components/reports/fileMethods";
import { getImgDataForCurrentView } from "@/components/reports/ReportsManager";
import {
  debugAnchorageResult,
  getMeshesBox,
  calculateAnchorAreas,
} from "./AnchorageCalculation";
import {
  getTeethBox,
  getTeethZoom,
  switchToMaxilla,
  switchToMandibular,
} from "../occlusal/OcclusalTools.js";
import { drawBox, drawLine, drawPoint } from "../draw/draw.js";
import { switchStitching } from "@/components/appStart/stitching";

//#region  Fields

let anchorViewersInitialized = false;

let allTeethBox = null;
let allTeethCenter = null;

let maxillaCenter = null;
let maxillaBox = null;
let maxillaZoom = null;

let mandibleCenter = null;
let mandibleBox = null;
let mandibleZoom = null;

let anchorageScene1 = null;
let anchorageScene2 = null;
let anchorageCamera1 = null;
let anchorageCamera2 = null;
let anchorageControls1 = null;
let anchorageControls2 = null;

const mainColor = "#00FFFF";
const opposingColor = "#00FF00";

let view_dy = 3;
let view_dz = 6;
let cameraDistance = 32;

//#endregion

function enterAnchorageMode() {
  console.log("enterAnchorageMode");
  $("#anchorageWizard").modal();
  setTimeout(function () {
    initAnchorViewers();
  }, 300);
}

function setCenters() {
  allTeethBox = offsetBox(getMeshesBox(vueApp.teethMeshes));
  allTeethCenter = new THREE.Vector3(
    allTeethBox.center.x,
    allTeethBox.center.y,
    allTeethBox.min.z + view_dz * 2
  );

  maxillaBox = offsetBox(getTeethBox(true));
  maxillaCenter = new THREE.Vector3(
    maxillaBox.center.x,
    maxillaBox.min.y + view_dy,
    maxillaBox.min.z + view_dz * 2
  );
  maxillaZoom = getTeethZoom(maxillaBox) * 1.2; // / 2;

  mandibleBox = offsetBox(getTeethBox(false));
  mandibleCenter = new THREE.Vector3(
    mandibleBox.center.x,
    mandibleBox.max.y - view_dy * 1.8,
    mandibleBox.min.z + view_dz * 2
  );
  mandibleZoom = getTeethZoom(mandibleBox) * 1.2; // / 2;
}

function initAnchorViewers() {
  if (!anchorViewersInitialized) {
    setCenters();

    $(".anchorage-spinner").css({ display: "block" });
    let containers = ["anchorage1Viewer", "anchorage2Viewer"];

    containers.forEach((containerId, index) => {
      const container = document.getElementById(containerId);
      const scene = createScene(container, index);
      vueApp.allTeeth.forEach((tooth) => {
        let toothMesh = viewer.get_model_mesh(tooth.id);
        let toothGeometry = toothMesh.stitchedGeometry
          ? toothMesh.stitchedGeometry
          : toothMesh.geometry;
        let anchorageMesh = new THREE.Mesh(
          toothGeometry.clone(),
          toothMesh.originalMaterial.clone()
        );
        anchorageMesh.material.color = new THREE.Color("#FFFFFF");
        scene.add(anchorageMesh);
        anchorageMesh.position.copy(toothMesh.position);
        anchorageMesh.rotation.copy(toothMesh.rotation);
        anchorageMesh.visible = toothMesh.visible && tooth.isUpper; // == !index;

        anchorageMesh.model = tooth;
        anchorageMesh.mainMesh = toothMesh;

        if (!toothMesh.anchorageMeshes) {
          toothMesh.anchorageMeshes = [];
        }
        toothMesh.anchorageMeshes.push(anchorageMesh);
      });

      if (isTouchEnabled()) {
        container.addEventListener("touchstart", function (e) {
          var event = e.targetTouches[0];
          onAnchorViewerMouseDown(event, container, scene, index);
        });
      } else {
        container.addEventListener(
          "mousedown",
          function (e) {
            // var event = e.targetTouches[0];
            onAnchorViewerMouseDown(e, container, scene, index);
          },
          false
        );
      }
    });

    switchToMaxilla1();
    switchToMaxilla2();

    $(".anchorage-spinner").css({ display: "none" });
    anchorViewersInitialized = true;
  } else {
    anchorageScene1.children
      .concat(anchorageScene2.children)
      .forEach((anchorageMesh) => {
        if (anchorageMesh.model && anchorageMesh.material) {
          anchorageMesh.isSelected = false;
          anchorageMesh.material.color = new THREE.Color("#FFFFFF");

          let mainMesh = anchorageMesh.mainMesh;
          anchorageMesh.position.copy(mainMesh.position);
          anchorageMesh.rotation.copy(mainMesh.rotation);
          anchorageMesh.visible = mainMesh.visible && anchorageMesh.visible;
          let originalMaterial = mainMesh.originalMaterial ? mainMesh.originalMaterial : mainMesh.material;
          anchorageMesh.material.opacity = originalMaterial.opacity;
        }
      });
  }
}

//#region Occlusal

function switchToMaxilla1() {
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[0].visible = toothMesh.visible && tooth.isUpper;
    }
  });

  switchViewerToMaxilla(anchorageCamera1, anchorageControls1);
}

function switchToMandibular1() {
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[0].visible = toothMesh.visible && !tooth.isUpper;
    }
  });

  switchViewerToMandibular(anchorageCamera1, anchorageControls1);
}

function switchToMaxilla2() {
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[1].visible = toothMesh.visible && tooth.isUpper;
    }
  });

  switchViewerToMaxilla(anchorageCamera2, anchorageControls2);
}

function switchToMandibular2() {
  vueApp.allTeeth.forEach((tooth) => {
    let toothMesh = viewer.get_model_mesh(tooth.id);
    if (toothMesh.anchorageMeshes) {
      toothMesh.anchorageMeshes[1].visible = toothMesh.visible && !tooth.isUpper;
    }
  });

  switchViewerToMandibular(anchorageCamera2, anchorageControls2);
}

function switchViewerToMaxilla(camera, controls) {
  let teethBox = maxillaBox;
  let teethZoom = maxillaZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y = teethBox.center.y - teethZoom;
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = 1;

  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
  controls.target = new THREE.Vector3(point.x, point.y, point.z);
}

function switchViewerToMandibular(camera, controls) {
  let teethBox = mandibleBox;
  let teethZoom = mandibleZoom;

  camera.position.x = teethBox.center.x;
  camera.position.y = teethBox.center.y + teethZoom;
  camera.position.z = teethBox.center.z;
  camera.up.y = 0;
  camera.up.x = 0;
  camera.up.z = -1;
  let point = teethBox.center;
  camera.lookAt(point.x, point.y, point.z);
  controls.target = new THREE.Vector3(point.x, point.y, point.z);
}

//#endregion

//#region Scene

function createScene(container, index) {
  let rect = container.getBoundingClientRect();
  let width = rect.width;
  let height = rect.height;

  const scene = new THREE.Scene();
  if (index === 0) {
    anchorageScene1 = scene;
  } else if (index === 1) {
    anchorageScene2 = scene;
  }
  scene.background = new THREE.Color("#082F5E");

  const renderer = new THREE.WebGLRenderer();
  renderer.setSize(width, height);

  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1e4);
  camera.position.x = 20;
  camera.position.z = 50;
  scene.add(camera);
  scene.camera = camera;

  scene.raycaster = new THREE.Raycaster(
    scene.camera.position,
    new THREE.Vector3(0, 0, 0),
    0.1,
    100000
  );

  if (index === 0) {
    anchorageCamera1 = camera;
  } else if (index === 1) {
    anchorageCamera2 = camera;
  }

  addSceneLights(scene, camera);

  // camera.aspect = width / height;
  // camera.updateProjectionMatrix();
  // renderer.setSize(width, height);

  container.appendChild(renderer.domElement);
  const controls = new THREE.AstroControls(camera, renderer.domElement);
  controls.enabled = false;
  if (index === 0) {
    anchorageControls1 = controls;
  } else if (index === 1) {
    anchorageControls2 = controls;
  }
  // scene.add(new THREE.AxesHelper(180));
  // const geometry = new THREE.BoxGeometry(1, 1, 1);
  // const material = new THREE.MeshBasicMaterial({
  //   color: 0xffff00,
  //   wireframe: true,
  // });
  // const cube = new THREE.Mesh(geometry, material);
  // scene.add(cube);

  function animate() {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
    controls.update();
  }
  animate();
  return scene;
}

function addSceneLights(scene, camera) {
  let ambientLight = new THREE.AmbientLight(0x202020);
  scene.add(ambientLight);

  let dirIntensity = 0.2;
  let directionalLight1 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight1.position.x = 1;
  directionalLight1.position.y = 0;
  directionalLight1.position.z = 0;
  scene.add(directionalLight1);

  let directionalLight2 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight2.position.x = 1;
  directionalLight2.position.y = 0;
  directionalLight2.position.z = 0;
  scene.add(directionalLight2);

  let directionalLight3 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight3.position.x = 0;
  directionalLight3.position.y = 0;
  directionalLight3.position.z = 1;
  scene.add(directionalLight3);

  let directionalLight4 = new THREE.DirectionalLight(0xffffff, dirIntensity);
  directionalLight4.position.x = 0;
  directionalLight4.position.y = 0;
  directionalLight4.position.z = -1;
  scene.add(directionalLight4);

  let pointLight = new THREE.PointLight(0xffffff, 0.55);
  pointLight.position.set(0, 0, 0);
  camera.add(pointLight);
}

//#endregion

//#region Events

function onAnchorViewerMouseDown(event, container, scene, viewerIndex) {
  let x = event.offsetX;
  let y = event.offsetY;

  // console.log("onAnchorViewerMouseDown", x, y, container, scene);

  let rect = container.getBoundingClientRect();
  let width = rect.width;
  let height = rect.height;
  let mouse3D = new THREE.Vector3(
    (x / width) * 2 - 1,
    -(y / height) * 2 + 1,
    0.5
  );

  mouse3D.unproject(scene.camera);
  mouse3D.sub(scene.camera.position);
  mouse3D.normalize();

  scene.raycaster.set(scene.camera.position, mouse3D);

  let intersects = scene.raycaster.intersectObjects(scene.children);
  for (const intersect of intersects) {
    let anchorageMesh = intersect.object;
    let tooth = anchorageMesh.model;
    if (tooth && !tooth.extracted && anchorageMesh.visible) {
      let color = viewerIndex === 0 ? mainColor : opposingColor;
      let isSelected = !anchorageMesh.isSelected;

      if (isSelected) {
        let oppositeScene =
          scene == anchorageScene1 ? anchorageScene2 : anchorageScene1;

        let hasOppositeSelected = !!oppositeScene.children.find(
          (c) => c.isSelected && c.model == anchorageMesh.model
        );
        if (hasOppositeSelected) {
          swal("This tooth is already selected on opposite");
          break;
        }
      }

      anchorageMesh.isSelected = isSelected;
      color = anchorageMesh.isSelected ? color : "#FFFFFF";
      anchorageMesh.material.color = new THREE.Color(color);
      break;
    }
  }
}

//#endregion

//#region Report

function generateAnchorageReport() {
  let currentSourceType = vueApp.viewSourceType;
  switchStitching("cbct");

  let allMeshes = [];
  let meshes1 = [];
  let meshes2 = [];

  let anchorageTeeth1 = [];
  anchorageScene1.children.forEach((anchorageMesh) => {
    if (anchorageMesh.model && anchorageMesh.isSelected) {
      anchorageTeeth1.push(anchorageMesh.model);
      allMeshes.push(anchorageMesh.mainMesh);
      meshes1.push(anchorageMesh.mainMesh);
    }
  });
  if (!anchorageTeeth1.length) {
    swal("Select teeth for anchorage");
    return;
  }

  let anchorageTeeth2 = [];
  anchorageScene2.children.forEach((anchorageMesh) => {
    if (anchorageMesh.model && anchorageMesh.isSelected) {
      anchorageTeeth2.push(anchorageMesh.model);
      allMeshes.push(anchorageMesh.mainMesh);
      meshes2.push(anchorageMesh.mainMesh);
    }
  });
  if (!anchorageTeeth2.length) {
    swal("Select opposing teeth for anchorage");
    return;
  }

  let allAnchorageTeeth = anchorageTeeth1.concat(anchorageTeeth2);
  let meshesBox = getMeshesBox(allMeshes);
  let vcenter = new THREE.Vector3(
    meshesBox.center.x,
    meshesBox.center.y,
    meshesBox.center.z
  );
  calculateAnchorAreas(meshes1, meshes2);

  // drawBox(meshesBox, 0xFF00, viewer);
  // $("#anchorageWizard").modal("hide");
  // prepareViewToTooth(anchorageTeeth1[0], vcenter);
  // return;
  // debugAnchorageResult(
  //   meshes1,
  //   meshes2,
  //   allAnchorageTeeth,
  //   mainColor,
  //   opposingColor
  // );
  // return;

  console.log(
    "generateAnchorageReport",
    meshesBox,
    anchorageTeeth1,
    anchorageTeeth2
  );
  vueApp.leaveModes(true, false, false);

  allAnchorageTeeth.forEach(tooth => {
    setToothPointsOfView(tooth);
  });

  //#region prepare main view to screenshot

  let e = viewer.parent_element.getBoundingClientRect();
  let t = e.width;
  let a = t * 0.7;
  viewer.camera.aspect = t / a;
  viewer.camera.updateProjectionMatrix();
  viewer.renderer.setSize(t, a);

  let hasUpper = !!allAnchorageTeeth.find((t) => t.isUpper);
  let hasLower = !!allAnchorageTeeth.find((t) => !t.isUpper);
  let hasBoth = hasUpper && hasLower;

  let center = allTeethCenter;
  if (!hasBoth) {
    center = hasUpper ? maxillaCenter : mandibleCenter;
  }
  resetCameraUp();

  const cameraDistance = 50;
  let centersDistance = calculateDistance(vcenter, center);
  let coef = (centersDistance + cameraDistance) / centersDistance;

  let px = (vcenter.x - center.x) * coef + center.x;
  let py = (vcenter.y - center.y) * coef + center.y;
  let pz = (vcenter.z - center.z) * coef + center.z; // (vcenter.z - center.z) * coef + center.z; // vcenter.z;
  let centerCameraPoint = new THREE.Vector3(px, py, pz);

  viewer.camera.position.copy(centerCameraPoint);
  vueApp.lookAtPoint(vcenter);
  // viewer.camera.position.z = defaultZoom / 4 + meshesBox.center.z;

  vueApp.allItems.forEach((item) => {
    let mesh = viewer.get_model_mesh(item.id);
    if (mesh) {
      let isBone =
        vueApp.bones.includes(item) &&
        (hasBoth ||
          (item.isMaxilla && hasUpper) ||
          (!item.isMaxilla && hasLower));
      let isAnchorage = allAnchorageTeeth.includes(item);
      if (isBone) {
        mesh.visible = true;
        mesh.material.opacity = 0.3;
      } else mesh.visible = isAnchorage;

      if (isAnchorage) {
        let color = anchorageTeeth1.includes(item) ? mainColor : opposingColor;
        let material = mesh.originalMaterial
          ? mesh.originalMaterial
          : mesh.material;
        mesh.material = material;
        material.color = new THREE.Color(color);
      }
    }
  });

  //#endregion
  $("#anchorageSpinner").css({ display: "block" });
  let canvas = viewer.renderer.domElement;
  canvas.setAttribute("hidden", "hidden");

  const tmt = 150;
  const totalImgCount = 2 + allAnchorageTeeth.length;
  const imgArr = [];
  for (let i = 0; i < totalImgCount; i++) {
    setTimeout(function () {
      imgArr.push(getImgDataForCurrentView());
      if (i === 0) {
        prepareToOcclusal(hasUpper, allAnchorageTeeth);
      } else {
        let tooth = allAnchorageTeeth[i - 1];
        let isOpposite = anchorageTeeth2.includes(tooth);
        if (tooth) prepareViewToTooth(tooth, vcenter, isOpposite); //anchorCenter); vcenter
      }
    }, (i + 1) * tmt);
  }

  setTimeout(() => {
    generateAnchoragePdf(anchorageTeeth1, anchorageTeeth2, imgArr);
    switchStitching(currentSourceType);
    $("#anchorageWizard").modal("hide");

    viewer.do_resize();
    vueApp.leaveModes(true, false, false);
    vueApp.switchToDefaultView();
    canvas.removeAttribute("hidden");
    $("#anchorageSpinner").css({ display: "none" });
  }, (totalImgCount + 1) * tmt);
}

function generateAnchoragePdf(anchorageTeeth1, anchorageTeeth2, imgArr) {
  const pdf = new jsPDF();
  console.log("generateAnchoragePdf", pdf.getFontList());
  const pdfWidth = pdf.internal.pageSize.getWidth(); // 210
  const pdfHeight = pdf.internal.pageSize.getHeight(); // 297
  pdf.setFontSize(18);
  pdf.setFont("helvetica");
  const lineHeightFactor = 0.7;

  const headerText = "Anchorage Report";
  let headerDims = pdf.getTextDimensions(headerText);
  let headerWidth = headerDims.w;
  let headerHeight = headerDims.h;
  let headerTop = headerHeight * 1.5;
  const headerLeft = pdfWidth / 2 - headerWidth / 2;
  pdf.text(headerText, headerLeft, headerTop);

  let fontSize = 12;
  pdf.setFontSize(fontSize);
  let textLeft = 15;
  let textTop = headerTop + headerHeight * 2;

  let patientName = `Patient name: ${vueApp.patientFirstName} ${vueApp.patientLastName}`;
  let textDims = pdf.getTextDimensions(patientName);
  let textHeight = textDims.h;
  let lineHeight = textHeight * 2 * lineHeightFactor;
  pdf.text(patientName, textLeft, textTop);
  textTop += lineHeight;

  const lineDif = 0.5;
  const anchorText1 = "Anchor 1:";
  textDims = pdf.getTextDimensions(anchorText1);
  let lineTop = textTop + 1;
  pdf.line(
    textLeft - lineDif,
    lineTop,
    textLeft + textDims.w + lineDif,
    lineTop
  );
  pdf.text(anchorText1, textLeft, textTop);
  textTop += lineHeight;

  let areInDifferentQuarters = false;
  let allAnchorageTeeth = anchorageTeeth1.concat(anchorageTeeth2);
  let quarters = [];
  allAnchorageTeeth.forEach((tooth) => {
    let quarter = +(tooth.number + "")[0];
    // console.log("quarter", quarter);
    let oppositeQuarter = quarters.find((q) => Math.abs(q - quarter) === 1);
    if (oppositeQuarter) {
      areInDifferentQuarters = true;
    }
    quarters.push(quarter);
  });
  // console.log("areInDifferentQuarters", areInDifferentQuarters);

  let lastNumber1 = +anchorageTeeth1[0].number % 10;
  let lastNumber2 = +anchorageTeeth2[0].number % 10;

  let side1 =
    areInDifferentQuarters || lastNumber1 > lastNumber2 ? "Mesial" : "Distal";
  let anchorTotal1 = 0;
  anchorageTeeth1.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    let area = mesh.anchorArea;
    anchorTotal1 += area;
    let toothText = `Selected tooth ${tooth.number}. Bone interface area ${area} mm^2 on ${side1} side`;
    pdf.text(toothText, textLeft + 5, textTop);
    textTop += lineHeight;
  });
  let totalText = `Total: ${anchorTotal1.toFixed(1)} mm^2`;
  pdf.text(totalText, textLeft + 5, textTop);
  textTop += lineHeight;

  const anchorText2 = "Anchor 2:";
  textDims = pdf.getTextDimensions(anchorText2);
  lineTop = textTop + 1;
  pdf.line(
    textLeft - lineDif,
    lineTop,
    textLeft + textDims.w + lineDif,
    lineTop
  );
  pdf.text(anchorText2, textLeft, textTop);
  textTop += lineHeight;

  let side2 =
    areInDifferentQuarters || lastNumber2 > lastNumber1 ? "Mesial" : "Distal";
  let anchorTotal2 = 0;
  anchorageTeeth2.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    let area = mesh.anchorArea;
    anchorTotal2 += area;
    let toothText = `Selected tooth ${tooth.number}. Bone interface area: ${area} mm^2 on ${side2} side`;
    pdf.text(toothText, textLeft + 5, textTop);
    textTop += lineHeight;
  });
  totalText = `Total: ${anchorTotal2.toFixed(1)} mm^2`;
  pdf.text(totalText, textLeft + 5, textTop);
  textTop += lineHeight * 1.5;

  let anchorNumber = lastNumber2 > lastNumber1 ? 2 : 1;
  let positiveText = `Anchor ${anchorNumber} has a positive anchorage of ${Math.abs(anchorTotal1 - anchorTotal2)
    .toFixed(1)} on ${side2} side`;
  pdf.text(positiveText, textLeft, textTop);
  textTop += lineHeight;

  let expectedTitle = `Expected movement:`;
  pdf.text(expectedTitle, textLeft, textTop);
  textTop += lineHeight;

  let expectedMove1 = 1 - anchorTotal1 / (anchorTotal1 + anchorTotal2);
  expectedMove1 = (expectedMove1 * 100).toFixed(0);
  let expectedText1 = `Anchor 1 is expected to move: ${expectedMove1} %`;
  pdf.text(expectedText1, textLeft + 5, textTop);
  textTop += lineHeight;

  let expectedMove2 = 1 - anchorTotal2 / (anchorTotal1 + anchorTotal2);
  expectedMove2 = (expectedMove2 * 100).toFixed(0);
  let expectedText2 = `Anchor 2 is expected to move: ${expectedMove2} %`;
  pdf.text(expectedText2, textLeft + 5, textTop);
  textTop += lineHeight * 0.7;

  let imgData = imgArr[0];
  let imgProps = pdf.getImageProperties(imgData);

  const marginTop = 2;
  const marginLeft = textLeft;

  const teethImagesHeight = 100;
  let imgMaxWidth = (pdfWidth - marginLeft) / 2 - marginTop;
  let imgMaxHeight = pdfHeight - textTop - marginTop - teethImagesHeight;
  let imgWidthRel = imgMaxWidth / imgProps.width;
  let imgHeightRel = imgMaxHeight / imgProps.height;
  let imgMinRel = Math.min(imgWidthRel, imgHeightRel);
  let imgWidth = imgProps.width * imgMinRel;
  let imgHeight = imgProps.height * imgMinRel;

  let imgLeft = marginLeft;
  let imgTop = textTop;
  pdf.addImage(imgData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);

  let imgLeft2 = marginLeft + imgWidth + marginTop; //pdfWidth / 2;
  imgData = imgArr[1];
  pdf.addImage(imgData, "JPEG", imgLeft2, imgTop, imgWidth, imgHeight);

  textTop += imgHeight + lineHeight * 1.4;

  const atext1 = "Anchor 1 bone interface";
  const atext2 = "Anchor 2 bone interface";
  pdf.text(atext1, textLeft, textTop);
  pdf.text(atext2, imgLeft2, textTop);
  textTop += lineHeight * 0.7;

  imgMaxWidth = pdfWidth / 8;
  imgData = imgArr[2];
  imgProps = pdf.getImageProperties(imgData);
  imgWidthRel = imgMaxWidth / imgProps.width;
  imgHeightRel = imgMaxHeight / imgProps.height;
  imgMinRel = Math.min(imgWidthRel, imgHeightRel);
  imgWidth = imgProps.width * imgMinRel;
  imgHeight = imgProps.height * imgMinRel;

  let i = 1;
  imgLeft = marginLeft;
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(fontSize - 1);
  anchorageTeeth1.forEach((tooth, index) => {
    let toothImageData = imgArr[++i];
    if (index > 2) imgLeft = marginLeft;
    imgTop = index < 3 ? textTop : textTop + imgHeight + marginTop;
    pdf.addImage(toothImageData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);
    pdf.text(tooth.name, imgLeft + 1, imgTop + imgHeight - 1);
    imgLeft += imgWidth + 2;
  });

  imgLeft = imgLeft2;
  anchorageTeeth2.forEach((tooth, index) => {
    let toothImageData = imgArr[++i];
    if (index > 2) imgLeft = imgLeft2;
    imgTop = index < 3 ? textTop : textTop + imgHeight + marginTop;
    pdf.addImage(toothImageData, "JPEG", imgLeft, imgTop, imgWidth, imgHeight);
    pdf.text(tooth.name, imgLeft + 1, imgTop + imgHeight - 1);
    imgLeft += imgWidth + 2;
  });

  pdf.setTextColor(0, 0, 0);
  pdf.setFont(undefined, "bold");
  pdf.setFontSize(fontSize - 1);
  textTop = pdfHeight - lineHeight * 1.2;
  let noteText =
    "Please note - percentage movement is only an approximation and depends on the accuracy of the segmentation and varying differences in bone density.";
  noteText = pdf.splitTextToSize(noteText, pdfWidth - textLeft * 2);
  pdf.text(noteText, textLeft, textTop);

  //_${vueApp.patientFirstName}_${vueApp.patientLastName}
  let fullName = `anchorageReport_${getFormattedDate(true)}.pdf`;
  pdf.save(fullName);
}

function prepareToOcclusal(isMaxilla, allAnchorageTeeth) {
  vueApp.allTeeth.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    mesh.visible =
      tooth.isUpper == isMaxilla || allAnchorageTeeth.includes(tooth);
    mesh.material = mesh.originalMaterial;

    if (mesh.visible && !allAnchorageTeeth.includes(tooth)) {
      mesh.material.color = new THREE.Color("#FFFFFF");
    }
  });
  vueApp.bones.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = false;
  });
  // vueApp.lookAtPoint(new THREE.Vector3());
  // resetCameraUp();

  if (isMaxilla) switchToMaxilla(true);
  else switchToMandibular(true);
}

function setToothPointsOfView(tooth) {
  // console.log("setPointOfView", tooth.filename);
  let mesh = viewer.get_model_mesh(tooth.id);

  if (mesh) {
    let center = tooth.isMaxilla ? maxillaCenter : mandibleCenter;
    let toothBox = tooth.defaultBox;
    let toothGeometry = mesh.stitchedGeometry
      ? mesh.stitchedGeometry
      : mesh.geometry;
    toothGeometry.computeBoundingBox();
    toothBox = offsetBox(toothGeometry.boundingBox, mesh.position.x, mesh.position.y, mesh.position.z);
    mesh.geometryCenter = new THREE.Vector3(toothBox.center.x, toothBox.center.y, toothBox.center.z);

    let x = toothBox.center.x;
    // let y = tooth.isMaxilla ? toothBox.min.y + view_dy : toothBox.max.y;
    let y = toothBox.center.y;
    let z = toothBox.center.z;
    mesh.apexCenter = new THREE.Vector3(x, y, z);

    let distance = calculateDistance(mesh.apexCenter, center);
    let coef = (distance + cameraDistance) / distance;
    let px = (x - center.x) * coef + center.x;
    let py = (y - center.y) * coef + center.y;
    let pz = (z - center.z) * coef + center.z;
    mesh.cameraPoint = new THREE.Vector3(px, py, pz);
    // drawLine(mesh.position, mesh.cameraPoint);
  }
}

function prepareViewToTooth(tooth, anchorCenter, isOpposite) {
  let toothMesh = null;
  vueApp.allItems.forEach((model) => {
    let mesh = viewer.get_model_mesh(model.id);
    mesh.visible = tooth == model;
    // model.isVisible = mesh.visible;
    if (mesh.visible) {
      toothMesh = mesh;
      let rootColor = isOpposite ? opposingColor : mainColor;
      // mesh.originalMaterial.color = new THREE.Color("#FFFFFF");
      // mesh.rootCrownMaterials[1].color = new THREE.Color(rootColor);
      let m1 = mesh.originalMaterial.clone();
      m1.color = new THREE.Color("#FFFFFF");
      let m2 = mesh.originalMaterial.clone();
      m2.color = new THREE.Color(rootColor);
      let materials = [m1, m2];
      mesh.material = materials;
    }
  });

  let e = viewer.parent_element.getBoundingClientRect();
  let t = e.width;
  let a = t * 1.4;
  viewer.camera.aspect = t / a;
  viewer.camera.updateProjectionMatrix();
  viewer.renderer.setSize(t, a);

  resetCameraUp();

  let toothCenter = toothMesh.geometryCenter;
  // let cameraDistance = 35;
  // let toothCenter = toothMesh.position; // toothMesh.position; //.rootCenter;
  // // drawPoint(anchorCenter);
  // // drawLine(anchorCenter, toothCenter);

  // let centersDistance = calculateDistance(anchorCenter, toothCenter);
  // let coef = (centersDistance + cameraDistance) / centersDistance;

  // let px = (anchorCenter.x - toothCenter.x) * coef + toothCenter.x;
  // let py = (anchorCenter.y - toothCenter.y) * coef + toothCenter.y;
  // let pz = (anchorCenter.z - toothCenter.z) * coef + toothCenter.z;
  // let centerCameraPoint = new THREE.Vector3(px, py, pz);
  // viewer.camera.position.copy(centerCameraPoint);

  viewer.camera.position.copy(toothMesh.cameraPoint);

  vueApp.lookAtPoint(toothCenter);
  viewer.camera.updateProjectionMatrix();
  viewer.controls.update();
}

//#endregion

export {
  enterAnchorageMode,
  switchToMaxilla1,
  switchToMandibular1,
  switchToMaxilla2,
  switchToMandibular2,
  generateAnchorageReport,
};
